import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15px"
    height="15px"
    viewBox="0 0 15 15"
    space="preserve"
    style={{
      name: 'style',
      value: 'enable-background:new 0 0 15 15'
    }}>
    <path d="M13.1 8.2c0-.2.1-.5.1-.7 0-.3 0-.5-.1-.7l1.6-1.2c.1-.1.2-.3.1-.5l-1.5-2.6c-.1-.2-.3-.2-.5-.2l-1.9.7c-.4-.3-.8-.5-1.3-.7l-.3-2C9.3.1 9.2 0 9 0H6c-.2 0-.3.1-.4.3l-.3 2c-.4.2-.8.4-1.2.7l-1.9-.7c-.2-.1-.4 0-.4.2L.3 5c-.1.2-.1.4 0 .5l1.6 1.2c0 .2-.1.5-.1.7 0 .2 0 .5.1.7L.3 9.5c-.1.1-.1.3 0 .5l1.5 2.6c.1.2.3.2.5.2l1.8-.8c.4.3.8.5 1.3.7l.3 2c0 .2.1.3.3.3h3c.2 0 .3-.1.4-.3l.3-2c.5-.2.9-.4 1.3-.7l1.9.8c.2.1.4 0 .5-.2l1.5-2.6c.1-.2.1-.4-.1-.5l-1.7-1.3zm-5.6 1.9c-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6 2.6 1.2 2.6 2.6-1.2 2.6-2.6 2.6z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/settings.es6.js